import { render, staticRenderFns } from "./MenuCommon.vue?vue&type=template&id=2ea70c8e&scoped=true"
import script from "./MenuCommon.vue?vue&type=script&lang=js"
export * from "./MenuCommon.vue?vue&type=script&lang=js"
import style0 from "./MenuCommon.vue?vue&type=style&index=0&id=2ea70c8e&prod&lang=scss&scoped=true"
import style1 from "./MenuCommon.vue?vue&type=style&index=1&id=2ea70c8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea70c8e",
  null
  
)

export default component.exports